import apiClient from './Api';
const PREFIX = '/note';

const getVehicleNotes = postData => {
  return apiClient({
    url: `${PREFIX}/vehnotes`,
    method: 'POST',
    data: postData
  });
};

const updateVehicleNote = postData => {
  return apiClient({
    url: `${PREFIX}/update`,
    method: 'POST',
    data: postData
  });
};

const setNotVds = postData => {
  return apiClient({
    url: `${PREFIX}/notvds`,
    method: 'POST',
    data: postData
  });
};

const NotesService = { getVehicleNotes, updateVehicleNote, setNotVds };
export default NotesService;
